<template>
    <table class="table table-striped table-hover">
        <tbody>
        <tr class="table-header">
            <th v-for="(column, index) in tableLocal.columns"
                :style="{width: columnsSizes.length > index ? columnsSizes[index] : null }"
            >{{column}}</th>
            <th v-if="isEditable" style="width: 20px">
            </th>
        </tr>
        <tr v-for="(row, rowIndex) in tableLocal.rows">
            <td v-for="(column, index) in tableLocal.columns">
                <input class="form-control" v-if="isEditable" type="text" v-model="row[index]"  v-on:change.lazy="onTableChanged" style="width: 100%"/>
                <span v-else v-text="row[index]" ></span>
            </td>
            <td v-if="isEditable" style="padding: 10px 0">
                <span class="btn fas fa-trash" style="font-size: 18px" v-on:click="onDeleteRowClick(rowIndex)"></span>
            </td>

        </tr>
        <tr v-if="isEditable">
            <td :colspan="tableLocal.columns.length + 1">
                <button class="btn btn-info" v-on:click="onAddRowClick"> Add Row</button>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        name: 'editable-table',
        props: {
            value: Object,
            isEditable: {
                type: Boolean,
                default: true
            },
            columnsSizes: {  // :columns-sizes="['50%']" - columns without width will be stretched
                type: Array,
                default: function () { return [] }
            }
        },
        data() {
            return {
                tableLocal: {
                    columns: [],
                    rows:[
                        []
                    ],
                    aggregate: [],
                }
            };
        },
        methods: {
            onAddRowClick(){
                this.tableLocal.rows.push(new Array(this.tableLocal.columns.length));
                this.emitChanges();
            },
            onDeleteRowClick(index){
                this.tableLocal.rows.splice(index, 1);
                this.emitChanges();
            },
            onTableChanged(){
                this.recalculate();
                this.emitChanges();
            },
            emitChanges(){
                this.$emit('input', _.cloneDeep(this.tableLocal));
            },
            recalculate(){
                if (_.isEmpty(this.tableLocal.aggregate)) return;
                let self = this;
                let index = _.findIndex(this.tableLocal.rows, function(row) { 
                    return row[0] == self.tableLocal.aggregate[0]; 
                });
                if (index < 0) return;
                _.forEach(this.tableLocal.aggregate, function (a, i) {
                    if (a === 'sum') {
                        self.tableLocal.rows[index][i] = _.sum(self.columnValues(i));
                    } else if (a === 'min') {
                        self.tableLocal.rows[index][i] = _.min(self.columnValues(i));
                    } else if (a === 'max') {
                        self.tableLocal.rows[index][i] = _.max(self.columnValues(i));
                    } else if (a === 'moneyCommas(sum)') {
                        self.tableLocal.rows[index][i] = self.moneyCommas(_.sum(self.columnValues(i)), 2);
                    }
                });
            },
            columnValues(column){
                let self = this;
                return _.map(this.tableLocal.rows, function (row) {
                    return !_.isEmpty(self.tableLocal.aggregate) 
                        && row[0] === self.tableLocal.aggregate[0] 
                        ? 0 
                        : parseFloat((''+row[column]).replace(/[^0-9.]/g,''));
                });
            }
        },
        watch:{
            value(){
                this.tableLocal = _.cloneDeep(this.value);
                this.recalculate();
            },
            'value.rows'(){
                this.tableLocal = _.cloneDeep(this.value);
                this.recalculate();
            },
        },
        mounted() {
            this.tableLocal = _.cloneDeep(this.value);
        }
    }
</script>
